import axiosInstanceNew from "../lib/axiosinstanceNew";
const StudentLeaderboard = class {
    constructor() {
      this.baseUrl = "leaderboard/";
    }
    
    async Getlists() {
        return await axiosInstanceNew.get(`${this.baseUrl}student`)
    }

    async Addlist(data =[]) {
        return await axiosInstanceNew.post(`${this.baseUrl}`,data)
    }
};
export default new StudentLeaderboard();